import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-02e281f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "name" }

import {onMounted} from "vue";
import {useRoute} from "vue-router";
import Oauth2 from "@/utils/Oauth2";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

onMounted(async () => {
  let route = useRoute();
  let response = await Oauth2.getToken(route.query.code as string)
  if(!response) return window.location.replace("/");
  localStorage.setItem('token', response.accessToken)
  localStorage.setItem('refreshToken', response.refreshToken)
  window.location.replace("/@me")
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Login.name')), 1),
    _createVNode(_component_v_progress_circular, {
      size: 100,
      width: 7,
      indeterminate: ""
    })
  ]))
}
}

})